module.exports = __webpack_public_path__ + "static/media/announce_01.65ca15b4.jpg";